module.exports = __webpack_public_path__ + "img/RedBullLogo.3242e64f.svg";